require('./bootstrap');
require('./helpers/ie11-foreach-polyfill');
require('./applications');
require('./users');
require('./forms');
require('./total-score');
require('./helpers/sumUp');
require('./helpers/wordCounter');
require('./helpers/scrollToInvalidField');
require('./previewEvaluationModal');
